<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报表管理</el-breadcrumb-item>
      <el-breadcrumb-item>股东分红表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-date-picker
      v-model="reportRequestBody.selectMonth"
      type="monthrange"
      range-separator="至"
      start-placeholder="开始月份"
      end-placeholder="结束月份"
      size="mini"
      @change="selectReportDataMonth"
      value-format="yyyy-MM"
    >
    </el-date-picker>
    <el-select value filterable v-model="selectAreaId" v-if="orgLevel == 1" placeholder="请选择区域" clearable
               style="width: 200px" size="mini" @change="getArea">
      <el-option
        v-for="item in area"
        :key="item.id"
        :label="item.orgName"
        :value="item.id">
      </el-option>
    </el-select>
    <el-select v-model="selectOrgId" v-if="orgLevel < 3 " clearable value filterable placeholder="请选择门店"
               style="width: 200px" size="mini" @change="getShop">
      <el-option
        v-for="org in shop"
        :key="org.id"
        :label="org.orgName"
        :value="org.id">
      </el-option>
    </el-select>
    <el-select v-model="reportRequestBody.userId" v-if="orgLevel < 3"
               clearable value filterable placeholder="请选择员工"
               style="width: 200px" size="mini" @change="getUser">
      <el-option
        v-for="user in users"
        :key="user.id"
        :label="user.userName"
        :value="user.id">
      </el-option>
    </el-select>
    <el-button size="mini" @click="loadSalaryData">查询</el-button>
    <el-table height="600px" :data="profitList" fit border stripe="stripe"
              :header-cell-style="{background:'#eff3f8', color:'#333'}"
              show-summary
              class="table-fixed">
      <el-table-column
        align="center"
        prop="shopName"
        width="180"
        label="门店名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="userName"
        width="180"
        label="股东名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="rate"
        width="180"
        label="股份比例"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="yeji"
        width="150"
        label="业绩">
      </el-table-column>
      <el-table-column
        align="center"
        prop="huokuan"
        width="150"
        label="货款">
      </el-table-column>
      <el-table-column
        align="center"
        prop="caiwufeiyong"
        width="150"
        label="财务费用">
      </el-table-column>
      <el-table-column
        align="center"
        prop="gongzi"
        width="150"
        label="工资">
      </el-table-column>
      <el-table-column
        align="center"
        prop="jinglirun"
        width="150"
        label="净利润">
      </el-table-column>
      <el-table-column
        align="center"
        prop="yingyezhichu"
        width="150"
        label="营业支出">
      </el-table-column>
      <el-table-column
        align="center"
        prop="dianmianqitazhichu"
        width="150"
        label="店面其他支出">
      </el-table-column>
      <el-table-column
        align="center"
        prop="dianmianqitashouru"
        width="150"
        label="店面其他收入">
      </el-table-column>
      <el-table-column
        align="center"
        prop="xiaofeidantuifei"
        width="150"
        label="消费单退费">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data(){
    return{
      orgId:'',
      userId:'',
      shops:[],
      reportRequestBody:{
        startMonth:'',
        endMonth:'',
        shopId:'',
        selectMonth:'',
        userId:'',
        areaId:0
      },
      profitList:[],
      selectAreaId:'',
      selectOrgId:'',
      shop:[],
      area:[],
      users:[]
    }
  },
  methods:{
    selectReportDataMonth(data){
      if (data == null){
        this.reportRequestBody.selectMonth = '';
      } else {
        this.reportRequestBody.selectMonth = data;
        this.reportRequestBody.startMonth = data[0];
        this.reportRequestBody.endMonth = data[1];
      }
    },
    async loadSalaryData(){
      // this.reportRequestBody.shopId = this.orgId;
      const {data:res} = await this.$http.post(`/yield/profit/data`, this.reportRequestBody)
      this.profitList = res.data;
    },
    getCurrentMonth () {
      let date = new Date()
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      if (month < 10) month = '0' + month
      return date.getFullYear() + '-' + month;
    },
    async getShop(data){
      if (data !== ''){
        this.reportRequestBody.shopId = data;
        const {data:res} = await this.$http.get(`/org/users/${data}`);
        this.users = res.data;
      } else {
        this.users = []
        this.reportRequestBody.shopId = 0;
      }
    },
    async getArea(data){
      if (data !== ''){
        this.reportRequestBody.areaId = data;
        const {data:res} = await this.$http.get(`/orgs/area/orgId/${data}`);
        this.shop = res.data;
      } else {
        this.shop = []
        this.reportRequestBody.areaId = 0;
      }
    },
    getUser(data){
      if (data !== ''){
        // this.reportRequestBody.userId = data;
        this.selectUserId = data;
      } else {
        // this.reportRequestBody.userId = '';
        this.selectUserId = '';
      }
    },
    async loadAreaOrgs(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      if (res.code === 200){
        this.area = res.data;
      }
    },
    async loadShop(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      this.shop = res.data;
    },
    async loadUser(){
      const {data:res} = await this.$http.get(`/org/users/${this.orgId}`);
      this.users = res.data;
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    // this.reportRequestBody.userId = this.userId;
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    if (this.orgLevel == 1){
      this.loadAreaOrgs();
    }
    if (this.orgLevel == 2){
      this.reportRequestBody.orgLevel = this.orgLevel;
      this.reportRequestBody.areaId = this.orgId;
      this.loadShop();
    }
    if (this.orgLevel == 3){
      // this.reportRequestBody.orgLevel = this.orgLevel;
      // this.reportRequestBody.areaId = this.orgId;
      this.reportRequestBody.userId = this.userId;
      // this.loadShop();
    }
  }
}
</script>

<style lang="less" scoped>
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}

.table-fixed{
  /deep/.el-table__body-wrapper {
    height: calc(100% - 55px) !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/MyYield.vue